module.exports = __webpack_public_path__ + "static/media/rediet_abebe.92384c8c.jpg";